import AuthService from "@/services/AuthService";

class CKEditorUploadAdapter {
  url: string;
  loader: any;
  xhr: any;
  tokenAccessor: () => string;

  constructor(loader: any, url: string, tokenAccessor: () => string) {
    this.loader = loader;
    this.url = url;
    this.tokenAccessor = tokenAccessor;
  }

  upload() {
    return this.loader.file.then(
      (      file : any) =>
        new Promise((resolve, reject) => {
          if (file.size > 10000000) {
            reject("This file is too large.");
            return;
          }

          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());
    xhr.open("POST", this.url, true);
    xhr.setRequestHeader("Authorization", `Bearer ${this.tokenAccessor()}`);
    xhr.responseType = "json";
  }

  _initListeners(resolve: { (value: unknown): void; (arg0: { default: any; }): void; }, reject: { (reason?: any): void; (arg0: string | undefined): any; }, file: { size?: number; name?: any; }) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      resolve({
        default: response.url
      });
    });

    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt: { lengthComputable: any; total: any; loaded: any; }) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  _sendRequest(file: string | Blob) {
    const data = new FormData();
    data.append("file", file);
    this.xhr.send(data);
  }
}

export default function ckImageUploadPlugin(url: string, tokenAccessor?: () => string) {
  const getToken = tokenAccessor ?? (() => AuthService.token.token);

  return function(editor: { plugins: { get: (arg0: string) => { (): any; new(): any; createUploadAdapter: (loader: any) => CKEditorUploadAdapter; }; }; }) {
    editor.plugins.get("FileRepository").createUploadAdapter = loader => {
      return new CKEditorUploadAdapter(loader, url, getToken);
    };
  };
}
